import React from 'react';
import { useAnnouncementsContext } from 'src/global/contexts/AnnouncementsContext';
import { Megaphone } from 'lucide-react';
import { SidebarMenuItem, SidebarMenuButton } from 'src/shared/components/ui/sidebar';

const AnnouncementsMenu = () => {
    const { announcements, openModal } = useAnnouncementsContext();

    const handleClick = () => {
        openModal();
    };

    // Don't show the menu item if there are no announcements
    if (announcements.length === 0) {
        return null;
    }

    return (
        <SidebarMenuItem>
            <SidebarMenuButton tooltip='Announcements' onClick={handleClick}>
                <div className='relative'>
                    <Megaphone />
                    {announcements.length > 0 && (
                        <span className='absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-4 w-4 flex items-center justify-center'>
                            {announcements.length}
                        </span>
                    )}
                </div>
                <span>Announcements</span>
            </SidebarMenuButton>
        </SidebarMenuItem>
    );
};

export default AnnouncementsMenu;
